import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  Chip,
  Paper,
  CardActionArea,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import dayjs from "dayjs";
import { useImageUrl } from "hooks/useImageUrl";
import { ImageAvatar } from "components/Circle/shared/ImageAvatar";
// import EngineerRotationModal from "./engineer-rotation-modal";

interface payeeInfoType {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  displayImg: string | null;
  payoutDate: string;
  setOpen: (open: boolean) => void;
}

export default function CurrentPayeeCard({
  id,
  firstName,
  lastName,
  email,
  displayImg,
  payoutDate,
  setOpen,
}: payeeInfoType) {
  const { data: profilePictureUrl, isLoading: isLoadingImageUrl } =
    useImageUrl(displayImg);
  return (
    <>
      <Card
        elevation={1}
        sx={{
          width: "100%",
          maxWidth: 360,
          transition: "transform 0.2s, box-shadow 0.2s",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: 4,
          },
        }}
      >
        <CardActionArea onClick={() => setOpen(true)}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                mb: 2,
              }}
            >
              <Chip
                label="Current Rotation"
                color="primary"
                size="small"
                sx={{ height: 24, fontSize: "0.75rem" }}
              />
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Box
                sx={{
                  position: "relative",
                  mr: 2,
                }}
              >
                {displayImg ? (
                  <ImageAvatar displayImg={displayImg} firstName={firstName} />
                ) : (
                  <Avatar key={id}>
                    {firstName[0].toUpperCase()}
                    {lastName[0].toUpperCase()}
                  </Avatar>
                )}
                <Box
                  aria-hidden
                  sx={{
                    position: "absolute",
                    bottom: -4,
                    right: -4,
                    width: 14,
                    height: 14,
                    borderRadius: "50%",
                    bgcolor: "warning.light",
                    border: "2px solid white",
                  }}
                />
              </Box>

              <Box>
                <Typography
                  variant="h6"
                  component="h3"
                  sx={{ fontSize: "1.125rem", fontWeight: 600 }}
                >
                  {firstName} {lastName}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {email}
                </Typography>
                <Typography
                  variant="caption"
                  color="primary"
                  sx={{ mt: 0.5, display: "block", fontWeight: 500 }}
                >
                  Rotation Date:{" "}
                  {dayjs(String(payoutDate)).format("MMM D, YYYY")}
                </Typography>
              </Box>
            </Box>

            <Paper
              elevation={0}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 1,
                bgcolor: "rgba(25, 118, 210, 0.08)",
                borderRadius: 1,
                color: "primary.main",
              }}
            >
              <Typography variant="body2" sx={{ mr: 1 }}>
                View Full Rotation Schedule
              </Typography>
              <ExpandMoreIcon fontSize="small" />
            </Paper>
          </CardContent>
        </CardActionArea>
      </Card>
    </>
  );
}
